import { useState } from 'react';
import { Button, Toast, ToastContainer } from 'react-bootstrap';
import { FiRefreshCw } from 'react-icons/fi';
import { useAppUpdate } from './useAppUpdate';

// Aviso de versão nova do portal, em qualquer tela (login inclusive). Fica acima do topo e do menu (z-index 1000) e
// abaixo das janelas (modal 1050+), para não cobrir o Salvar de quem está no meio de um cadastro. Fechado, só volta
// ao recarregar a página
export default function AppUpdateNotice() {
  const available = useAppUpdate();
  const [closed, setClosed] = useState(false);

  return (
    <ToastContainer position='bottom-end' containerPosition='fixed' className='p-3' style={{ zIndex: 1045 }}>
      <Toast show={available && !closed} onClose={() => setClosed(true)}>
        <Toast.Header closeLabel='Fechar'>
          <FiRefreshCw className='me-2' aria-hidden='true' />
          <strong className='me-auto'>Nova versão disponível</strong>
        </Toast.Header>
        <Toast.Body className='d-flex align-items-center justify-content-between gap-3'>
          <span>Atualize para carregar as últimas melhorias.</span>
          <Button size='sm' variant='success' onClick={() => window.location.reload()}>Atualizar</Button>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}
